import Field from "components/shared/field";
import Select from "components/shared/select";
import { scenarioQuestionTypesEnum } from "helpers/enums";
import React from "react";
import { config } from "./config";

const ScenarioAnswerForm = (props) => {
    const { answerOption, onChange, questionOptions, removeAnswerOption, scenarioQuestion } = props;
    const { text, nextQuestionId, externalData } = config;
    return (
        <tr>
            <td>
                <Field {...text} onChange={onChange} value={answerOption.text} />
            </td>
            <td>
                <Field
                    {...externalData.config.propertyName}
                    onChange={({ name, value }) =>
                        onChange({ name: "externalData", value: { ...answerOption.externalData, [name]: value } })
                    }
                    value={answerOption.externalData?.propertyName || ""}
                />
            </td>
            {scenarioQuestionTypesEnum.SelectMultiple !== scenarioQuestion.questionType && (
                <td>
                    <Select
                        {...nextQuestionId}
                        onChange={onChange}
                        value={answerOption.nextQuestionId}
                        options={questionOptions}
                    />
                </td>
            )}
            <td className="align-middle scenarios__answer-action">
                <div className="link d-inline text-danger" onClick={removeAnswerOption}>
                    Удалить
                </div>
            </td>
        </tr>
    );
};

export default ScenarioAnswerForm;
